// Coerce a raw GTIN string into a 13-digit EAN-13 value.
// GS1 Digital Link URLs carry a GTIN-14 (e.g. "07896776800745"); EAN-13
// expects 13 digits, so we drop the leading packaging indicator digit.
export function toEAN13(value) {
  if (!value) return "";
  const digits = value.toString().replace(/\D/g, "");
  if (digits.length === 14) return digits.slice(1);
  return digits;
}

export function generateGTIN13(base12) {
  const str = base12.toString();
  if (str.length !== 12) return "Error: Input must be 12 digits";

  const digits = str.split("").map(Number);

  let sum = 0;
  for (let i = 0; i < 12; i++) {
    sum += i % 2 === 0 ? digits[i] : digits[i] * 3;
  }

  const checkDigit = (10 - (sum % 10)) % 10;
  return str + checkDigit;
}

export function generateBarcode(base12) {
  const gtin13 = generateGTIN13(base12);
  if (typeof gtin13 !== "string" || gtin13.startsWith("Error")) return gtin13;

  const bars = gtin13.split("").map((digit) => {
    const d = parseInt(digit);
    return {
      digit: d,
      binary: ENCODINGS[d],
    };
  });

  return {
    gtin13,
    bars,
  };
}

// EAN-13 L-code encodings (binary representation)
const ENCODINGS = {
  0: "0001101",
  1: "0011001",
  2: "0010011",
  3: "0111101",
  4: "0100011",
  5: "0110001",
  6: "0101111",
  7: "0111011",
  8: "0110111",
  9: "0001011",
};
